import React from 'react';

interface BadgeProps {
  count: number;
}

const Badge: React.FC<BadgeProps> = ({ count }) => {
  return (
    <span
      className="mr-2 inline-flex items-center justify-center px-1 min-w-[1.5rem] text-[10px] font-medium rounded-md border bg-transparent"
      style={{
        color: '#D22630',
        borderColor: '#D22630',
        backgroundColor: 'rgba(237, 76, 81, 0.15)', // translucent D22630
        height: '1.5rem',
        lineHeight: '1.5rem',
        paddingTop: 0,
        paddingBottom: 0,
      }}
    >
      {count}
    </span>
  );
};

export default Badge;
